
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.css';

import '../css/gallery.css'
var thumbSwiper = new Swiper(".thumbswiper", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 8,
    freeMode: true,
    watchSlidesProgress: true,
})

var swiper = new Swiper(".mySwiper", {
    modules: [Navigation, Thumbs],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: thumbSwiper,
    },
});

//document.querySelector('.swiper-button-next').addEventListener('click', () => {
//    swiper.slideNext();
//});
//document.querySelector('.swiper-button-prev').addEventListener('click', () => {
//    swiper.slidePrev();
//});

new SimpleLightbox('.mySwiper .swiper-slide a', { /* options */ });

console.log('Gallery JS loaded');
